/*
 * ARANOX — Portal Corporativo
 * ARX-PORTAL-002.02 — Menu Corporativo REV04
 * ARX_BS_018.04.02 — Refinamento visual incremental REV02
 */

import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { makeStyles } from '@material-ui/core';

import HomeIcon from '@material-ui/icons/Home';
import SearchIcon from '@material-ui/icons/Search';
import BusinessIcon from '@material-ui/icons/Business';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import BuildIcon from '@material-ui/icons/Build';
import EcoIcon from '@material-ui/icons/Eco';
import SecurityIcon from '@material-ui/icons/Security';
import ExtensionIcon from '@material-ui/icons/Extension';
import AppsIcon from '@material-ui/icons/Apps';
import StorageIcon from '@material-ui/icons/Storage';
import TimelineIcon from '@material-ui/icons/Timeline';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import PublicIcon from '@material-ui/icons/Public';
import FolderIcon from '@material-ui/icons/Folder';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import AssessmentIcon from '@material-ui/icons/Assessment';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import SettingsIcon from '@material-ui/icons/Settings';
import MenuIcon from '@material-ui/icons/Menu';

import { SidebarLogo } from './SidebarLogo';
import { useCorporateAccess } from '../permissions/useCorporateAccess';

const useSidebarGlobalStyles = makeStyles({
  '@global': {
    '.MuiDrawer-root .MuiDrawer-paper': {
      color: '#dce8ed',
      background:
        'radial-gradient(circle at 18% 8%, rgba(33, 145, 158, 0.18), transparent 24%), linear-gradient(180deg, #071522 0%, #0a2637 54%, #073d42 100%)',
      borderRight: '1px solid rgba(110, 231, 220, 0.14)',
      boxShadow: '12px 0 34px rgba(4, 18, 31, 0.18)',
    },
    '.MuiDrawer-root .MuiListItem-root': {
      borderRadius: 12,
      margin: '3px 10px',
      width: 'calc(100% - 20px)',
      color: 'rgba(237, 246, 248, 0.78)',
      transition:
        'background 160ms ease, color 160ms ease, transform 160ms ease, box-shadow 160ms ease',
    },
    '.MuiDrawer-root .MuiListItem-root:hover': {
      color: '#ffffff',
      background: 'rgba(110, 231, 220, 0.10)',
      transform: 'translateX(2px)',
    },
    '.MuiDrawer-root .MuiListItem-root[aria-current="page"]': {
      color: '#ffffff',
      background:
        'linear-gradient(90deg, rgba(110, 231, 220, 0.24), rgba(23, 76, 120, 0.20))',
      boxShadow:
        'inset 3px 0 0 #6ee7dc, 0 8px 24px rgba(2, 15, 24, 0.18)',
    },
    '.MuiDrawer-root .MuiListItemIcon-root': {
      minWidth: 40,
      color: '#6ee7dc',
    },
    '.MuiDrawer-root .MuiListItemIcon-root svg': {
      color: '#6ee7dc',
    },
    '.MuiDrawer-root .MuiListItemText-primary': {
      fontSize: '0.88rem',
      fontWeight: 650,
      letterSpacing: '0.01em',
    },
    '.MuiDrawer-root .MuiDivider-root': {
      margin: '10px 12px',
      backgroundColor: 'rgba(255, 255, 255, 0.10)',
    },
    '.MuiDrawer-root .MuiListSubheader-root': {
      color: 'rgba(237, 246, 248, 0.54)',
      background: 'transparent',
      fontSize: '0.67rem',
      fontWeight: 800,
      letterSpacing: '0.16em',
      textTransform: 'uppercase',
    },
    '.MuiDrawer-root .MuiCollapse-container': {
      background: 'rgba(255, 255, 255, 0.015)',
    },
    '.MuiDrawer-root .MuiCollapse-container .MuiListItem-root': {
      paddingLeft: 18,
    },
    '.MuiDrawer-root a': {
      textDecoration: 'none',
    },
    '.MuiDrawer-root a:hover': {
      textDecoration: 'none',
    },
  },
});

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      useSidebarGlobalStyles();
      const access = useCorporateAccess();

      const nav = navItems.withComponent(item => (
        <SidebarItem
          icon={() => item.icon}
          to={item.href}
          text={item.title}
        />
      ));

      return (
        <Sidebar>
          <SidebarLogo />

          <SidebarGroup label="Pesquisa" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>

          <SidebarDivider />

          <SidebarScrollWrapper>
            <SidebarItem icon={HomeIcon} to="/" text="Home" />

            {access.showCompanies && (
            <SidebarGroup label="Empresas" icon={<BusinessIcon />}>
              {access.can('aranox') && (              <SidebarItem icon={AccountBalanceIcon} to="/catalog/default/group/aranox" text="ARANOX" />)}
              {access.can('tes') && (              <SidebarItem icon={BuildIcon} to="/catalog/default/group/tes" text="TES" />)}
              {access.can('agrion') && (              <SidebarItem icon={EcoIcon} to="/catalog/default/group/agrion" text="AGRION" />)}
              {access.can('sentrix') && (              <SidebarItem icon={SecurityIcon} to="/catalog/default/group/sentrix" text="SENTRIX" />)}
            </SidebarGroup>
            )}

            {access.showPlatforms && (
            <SidebarGroup label="Plataformas" icon={<ExtensionIcon />}>
              {access.can('vitalis') && (              <SidebarItem icon={TimelineIcon} to="/catalog/default/system/vitalis" text="VITALIS" />)}
              {access.can('cyrius') && (              <SidebarItem icon={AccountTreeIcon} to="/catalog/default/system/cyrius" text="CYRIUS" />)}
              {access.can('cyrion') && (              <SidebarItem icon={PublicIcon} to="/catalog/default/system/cyrion" text="CYRION" />)}
            </SidebarGroup>
            )}

            {access.isAdmin && (
            <SidebarGroup label="Aplicações" icon={<AppsIcon />}>
              <SidebarItem icon={StorageIcon} to="/catalog/default/component/erpnext" text="ERPNext" />
              <SidebarItem icon={VpnKeyIcon} to="/catalog/default/component/keycloak" text="Keycloak" />
              <SidebarItem icon={AssessmentIcon} to="/catalog/default/component/grafana" text="Grafana" />
              <SidebarItem icon={AccountTreeIcon} to="/catalog/default/component/kestra" text="Kestra" />
              <SidebarItem icon={ExtensionIcon} to="/catalog/default/component/apisix" text="APISIX" />
              <SidebarItem icon={TimelineIcon} to="/catalog/default/component/prometheus" text="Prometheus" />
              <SidebarItem icon={MenuBookIcon} to="/catalog/default/component/loki" text="Loki" />
              <SidebarItem icon={AssessmentIcon} to="/catalog/default/component/uptime-kuma" text="Uptime Kuma" />
            </SidebarGroup>
            )}

            <SidebarDivider />

            {access.recognized && (            <SidebarItem icon={FolderIcon} to="/catalog?filters[kind]=component" text="Projetos" />)}
            {access.recognized && (            <SidebarItem icon={MenuBookIcon} to="/docs" text="Documentação" />)}
            {access.recognized && (            <SidebarItem icon={AssessmentIcon} to="/catalog?filters[kind]=resource" text="Operações" />)}
            {access.isAdmin && (            <SidebarItem icon={SupervisorAccountIcon} to="/settings" text="Administração" />)}

            <SidebarDivider />

            {access.isAdmin && (
            <SidebarGroup label="Recursos do portal" icon={<MenuIcon />}>
              {nav.rest({ sortBy: 'title' })}
            </SidebarGroup>
            )}
          </SidebarScrollWrapper>

          <SidebarSpace />

          <SidebarDivider />

          <SidebarItem icon={SettingsIcon} to="/settings" text="Configurações" />
        </Sidebar>
      );
    },
  },
});
